module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      staticClass: "wrapper"
    }, [_c('img', {
      attrs: {
        "src": item.thumbUrl || item.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.setActive(index)
        }
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172e7c2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/images/components/gallery.vue
// module id = 533
// module chunks = 0